import * as React from 'react';
import { Box, Container, Typography } from '@mui/material';
// import CookieConsent from "react-cookie-consent";
import { HashLink } from 'react-router-hash-link';

export default function Footer() {
    return (
        <Box className="Footer">
            <Container maxWidth="lg" className="container FooterContainer">

                <Box className="FooterLeft">
                    <img src="HT-Logo-white.png" className='brandLogoFooter' />
                    <Typography variant='body1' paragraph className='whiteText'>
                    Harbecke & Thelen Notare<br />
                    Holzgasse 29 - 33<br />
                    Siegburg 53721<br />
                                                            </Typography>
                </Box>

                <Box className="FooterRight">      
                <HashLink className='FooterLink' style={{ textDecoration: 'none' }} smooth to="/Datenschutz#">Privacy Policy</HashLink>
                <HashLink className='FooterLink' style={{ textDecoration: 'none' }} smooth to="/Impressum#">Imprint</HashLink>        
                </Box>
                
            </Container>

            {/* <CookieConsent
                location="bottom"
                buttonText="Verstanden"
                cookieName="myAwesomeCookieName2"
                style={{ background: "#9AAFB7" }}
                buttonStyle={{ color: "#ffffff", fontSize: "16px" }}
                expires={150}
            >
                <Typography variant='body1'>Diese Website verwendet nur technisch notwendige Cookies, um die Funktionalität zu gewährleisten. Es werden keine persönlichen Daten gesammelt.{" "}</Typography> 
            </CookieConsent> */}

        </Box>
    );
}